

$(".personalization-popup input").keyup(function () {
  var val_l = $(".personalization-popup input").val();
  $(".personalization-popup figure span").text(val_l);
  if (val_l.length > 0) {
    jQuery(".product-form__submit_popup").prop("disabled", false);
  } else {
    jQuery(".product-form__submit_popup").prop("disabled", true);
  }

  $(".custome_field_name").val(val_l);
});

$(".product-form__submit_popup").on("click", function () {
  $(".product-form__submit").trigger("click");
  $(".custome_field_name").val("");
  // $('.custome_field_color').val("");
  $("body").removeClass("popup-active");
  jQuery(".personalization-popup-section").hide();
});

// menu hover code start
document.addEventListener("DOMContentLoaded", function () {
  const megaMenus = document.querySelectorAll(".ct-mega-menu");

  megaMenus.forEach(function (megaMenu) {
    const summary = megaMenu.querySelector("summary");

    megaMenu.addEventListener("mouseenter", function () {
      summary.setAttribute("aria-expanded", "true");
      megaMenu.setAttribute("open", "");
    });

    megaMenu.addEventListener("mouseleave", function () {
      summary.setAttribute("aria-expanded", "false");
      megaMenu.removeAttribute("open");
    });
  });
});
// menu hover code end

// CSS Auto scroll JS
var sliders = document.querySelectorAll(".items_scroll");
var isDown = false;
var startX;
var scrollLeft;

sliders.forEach((slider) => {
  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
    slider.classList.remove("active");
    enableLinks(); // Re-enable links on mouse leave
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
    slider.classList.remove("active");
    enableLinks(); // Re-enable links on mouse up
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 1; // scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    disableLinks(); // Disable links when scrolling horizontally
  });
});

function disableLinks() {
  var links = document.querySelectorAll(".items_scroll .ct-scroll-box");
  links.forEach((link) => {
    link.style.pointerEvents = "none"; // Disable link clicks
  });
}

function enableLinks() {
  var links = document.querySelectorAll(".items_scroll .ct-scroll-box");
  links.forEach((link) => {
    link.style.pointerEvents = "auto"; // Re-enable link clicks
  });
}

$(document).ready(function () {
  // $(".ct_single_heroslider").slick({
  //   infinite: true,
  //   arrows: true,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  //   pauseOnHover: true,
  // });

//   var $slider = $(".ct_spacil_item");
//   var $progressBar = $(".progress");
//   var $progressBarLabel = $(".progress_bar");

//   $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
//     var calc = (nextSlide / (slick.slideCount - 1)) * 100;

//     $progressBar.css("background-size", calc + "% 100%");
//     $progressBar.attr("aria-valuenow", calc);

//     $progressBarLabel.text(calc + "% completed");
//   });

//   $(".ct_spacil_item").on("init", function (event, slick) {
//     $(this).append(
//       '<div class="slider-count ct-slider-count-main"><p><span id="current">1</span> / <span id="total">' +
//         slick.slideCount +
//         "</span></p></div>"
//     );
//   });
//   $(".ct_spacil_item").slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     // fade: true
//   });
//   $(".ct_spacil_item").on(
//     "afterChange",
//     function (event, slick, currentSlide, nextSlide) {
//       // finally let's do this after changing slides
//       $(".slider-count #current").html(currentSlide + 1);
//     }
//   );
 });

// add to cart start
$(".ct-bag-add-to-cart").click(function (e) {
  e.preventDefault();
  var variantId = $(this).attr("data-id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      items: [{ id: variantId, quantity: 1 }],
    },
    success: (data) => {
      $("#cart-notification").addClass("active");
      //setTimeout(function(){
      //  $('#cart-notification').removeClass('active');
      //},1000);
    },
    error: (err) => {
      console.error("err", err);
    },
  });
});
// add to cart end

// Variant image change start
$(document).ready(function () {
  // Function to check and update the Add to Cart button status
  function checkVariantStatus() {
    $(".ct-custom-pro-var-main").each(function () {
      if ($(this).hasClass("active")) {
        var parentVariant = $(this);
        var addToCartButton = parentVariant
          .closest(".item")
          .find(".quick-add__submit");
        var soldOutMessage = addToCartButton.find(".sold-out-message");
        var addToCartText = addToCartButton.find("span").first();

        if (parentVariant.hasClass("not_inventory_quantity")) {
          // console.log('Variant is out of stock on page load');

          // Disable the Add to Cart button
          addToCartButton.prop("disabled", true);

          // Show the Sold out message
          soldOutMessage.removeClass("hidden");

          // Hide the Add to Cart text
          addToCartText.addClass("hidden");
        } else {
          // console.log('Variant is in stock on page load');

          // Enable the Add to Cart button
          addToCartButton.prop("disabled", false);

          // Hide the Sold out message
          soldOutMessage.addClass("hidden");

          // Show the Add to Cart text
          addToCartText.removeClass("hidden");
        }
      }
    });
  }

  // Call the function on page load
  checkVariantStatus();

  // Function to match color code to color name
  function color_match(hexColor) {
    const wordToHex = {
      Black: "#000000",
      Black_Orange: "#FF624D",
      Orange: "#f06351",
      Blue: "#87d0da",
      White: "#ffffff",
      Yellow: "#fbe498",
      Silver: "#c9d7da",
      Brown: "#cab598",
      Green: "#cde4d0",
      Maroon: "#7a3334",
      Navy_Blue: "#132056",
      Pink: "#f6b1c1",
      Yellow: "#fbe498",
    };

    const hexToWord = Object.fromEntries(
      Object.entries(wordToHex).map(([k, v]) => [v, k])
    );
    const fromHex = (hex) => hexToWord[hex.toLowerCase()];
    var colorName = fromHex(hexColor);
    // console.log(hexColor + " == " + colorName);
    return colorName;
  }
  // Event handler for variant click
  $(".ct-custom-product-variants-home span").click(function () {
    var var_id = jQuery(this).attr("data-id");
    var hex_code = jQuery(this).attr("data-color");
    var colr = color_match(hex_code);
    var Vimage = jQuery(this).attr("data-img");

    jQuery(this)
      .closest(".item")
      .find(".ct_single_item .ct_change_img")
      .attr("src", Vimage);
    jQuery(this)
      .closest(".item")
      .find(".ct_single_item .ct_change_img")
      .attr("srcset", Vimage);

    jQuery(this)
      .closest(".ct-custom-product-variants-home")
      .find(".ct-custom-pro-var-main")
      .removeClass("active");
    jQuery(this).closest(".ct-custom-pro-var-main").addClass("active");

    jQuery(this).closest(".item").find(".ct_variant_id").attr("value", var_id);

    var parentVariant = jQuery(this).closest(".ct-custom-pro-var-main");
    var addToCartButton = jQuery(this)
      .closest(".item")
      .find(".quick-add__submit");
    var soldOutMessage = addToCartButton.find(".sold-out-message");
    var addToCartText = addToCartButton.find("span").first();
    if (parentVariant.hasClass("not_inventory_quantity")) {
      addToCartButton.prop("disabled", true);
      soldOutMessage.removeClass("hidden");
      addToCartText.addClass("hidden");
    } else {
      addToCartButton.prop("disabled", false);
      soldOutMessage.addClass("hidden");
      addToCartText.removeClass("hidden");
    }
  });
});
// Variant image change End

// Proiduct page Add Personalised Tag (Engrave upto 5 letters) code start
let Tpage = __st.p;
// console.log(Tpage);
if (Tpage == "product") {
  let colorSwitch = document.querySelectorAll(".ct-add_Per-color-switch");
  let sColor = document.querySelector(
    ".ct-add_Per-color-inner .ct-add_Per-color-Sswitch"
  );
 
  colorSwitch.forEach((switchElement) => {
    switchElement.addEventListener("click", function (event) {
      document
        .querySelectorAll(".ct-add_Per-color-switch")
        .forEach((element) => {
          element.classList.remove("is_active");
        });
      switchElement.classList.add("is_active");
      let date = switchElement.getAttribute("Tcolor_data");
      sColor.innerHTML = date;
    });
  });
  let tagData = document.querySelector(".ct_add_Per_tag_btn");
  if (tagData != null) {
    tagData.addEventListener("click", function (event) {
      let tagName = document.querySelector(".ct-add_Per-tag-input input").value;
      let tagColor = document.querySelector(
        ".ct-add_Per-color-Sswitch"
      ).innerHTML;
      let setDataName = document.querySelector(".custome_field_name");
      // let setDataColor = document.querySelector('.custome_field_color');

      setDataName.setAttribute("value", `${tagName}`);
      // setDataColor.setAttribute("value", `${tagColor}`);
      // setDataName.setAttribute("name", `properties[${tagName}]`);
      // setDataColor.setAttribute("name", `properties[${tagColor}]`);
      // console.log(`${tagName} tagName ${tagColor} tagColor`);
    });
  }

  let giftTextarea = document.querySelector(".ct-exclusive-gift-text textarea");
  if (giftTextarea != null) {
    giftTextarea.addEventListener("keyup", function () {
      let setTextarea = document.querySelector(".custome_field_textarea");
      setTextarea.setAttribute("value", `${this.value}`);
      this.value.toUpperCase();
    });
  }
}
// Proiduct page Add Personalised Tag (Engrave upto 5 letters) code End

function updateProductColors(value) {
  const productColors = document.querySelectorAll(".ct-product-color");
  productColors.forEach((element) => {
    element.textContent = " | " + value;
  });
}
document.querySelectorAll(".ct-variant-image").forEach((element) => {
  element.addEventListener("click", function () {
    const value = this.getAttribute("data-value");
    updateProductColors(value);
  });
});
window.addEventListener("load", function () {
  const initialElement = document.querySelector(
    ".ct-variant-image-main input[type=radio]:checked"
  );
  console.log(initialElement);
  if (initialElement) {
    const initialValue = initialElement.getAttribute("value");
    console.log(initialValue);
    updateProductColors(initialValue);
  }
});
// Product name with variant color name End

// Gifting page More info section showing Code Start
$(document).ready(function () {
  var currentURL = window.location.href;
  var targetDiv = $(".ct-gift-cart-info");
  targetDiv.hide();
  if (
    currentURL == "https://icon.in/a/gc/gift-card/" ||
    currentURL == "http://website.com/wp/tag/drink"
  ) {
    targetDiv.show();
  }
});
// Gifting page More info section showing Code End
// cart Drawer Offer code start
$(document).ready(function () {
  const checkCartDrawer = setInterval(function () {
    if ($(".drawer").hasClass("active")) {
      clearInterval(checkCartDrawer);
      $(".ct-cart-offer-see-all span").on("click", function () {
        $(this).closest(".ct-cart-offer-inner").addClass("is_open");
      });
      $(".ct-cart-offer-close").on("click", function () {
        $(this).closest(".ct-cart-offer-inner").removeClass("is_open");
      });
    }
  }, 100);
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (!$(".drawer").hasClass("active")) {
        $(".ct-cart-offer-inner").removeClass("is_open");
      }
    });
  });
  observer.observe(document.querySelector(".drawer"), {
    attributes: true,
    attributeFilter: ["class"],
  });
});
// cart Drawer Offer code End
